export default __webpack_public_path__ + "static/media/telegram-svgrepo-com.d06a63ef.svg";